import React, { Children } from 'react';

/**
 * A custom hook that takes in a children prop and an array of slot names
 * and returns an object of children that match the slot names.
 */
function useNamedSlots(children, slotNames) {
  const slots = {};
  Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;
    if (typeof child.type === 'string') return;
    // Check for the display name of this component.
    if (slotNames.includes(child.type?.displayName)) {
      slots[child.type.displayName] = child;
    }
  });
  return slots;
}

export default useNamedSlots;
